/**
 * Bind manual-confirmation links: open the manual confirmation modal and wire its content.
 *
 * The legacy dashboard already binds `.js-confirm-manually-modal` inside `.js-popover-content`
 * and `.js-showing-links-wrap`, but the new view popup renders the link in two new places:
 *   1. The header confirm button (rendered directly in `.js-showing-view-popup`).
 *   2. The popover dropdown clone inside `[data-tippy-root]` (the original click handler
 *      is bound to the source node in `.js-popover-content`, not to the cloned node).
 * This module ensures both call sites open the same `#manually-confirm-modal` template.
 */
export function initConfirmManuallyLink(link) {
  if (!link || link.dataset.confirmManuallyBound === 'true') {
    return;
  }

  link.dataset.confirmManuallyBound = 'true';
  link.addEventListener('click', handleConfirmManuallyClick);
}

export function initConfirmManuallyLinks(container) {
  if (!container) return;
  container.querySelectorAll('.js-confirm-manually-modal').forEach((link) => {
    initConfirmManuallyLink(link);
  });
}

function handleConfirmManuallyClick(e) {
  e.preventDefault();
  e.stopPropagation();

  const link = e.currentTarget;
  const template = document.querySelector('#manually-confirm-modal');
  if (!template) return;

  if (typeof SMDropdown !== 'undefined') {
    SMDropdown.closeAll();
  }

  document.dispatchEvent(new CustomEvent('sm-modal:open', {
    detail: {
      content: template.innerHTML,
      onComplete: () => {
        const wrapper = document.querySelector('#manual-confirmation-popup-content');
        if (!wrapper) return;
        wrapper.dataset.url = link.dataset.linkUrl;
        wrapper.dataset.method = wrapper.querySelector('.js-confirm-link').dataset.method;
      }
    }
  }));
  return false;
}
